import { createContext, useState } from 'react';
import * as React from 'react';

export const GenericContext = createContext({
  licensesSpdxIds: null,
  setLicensesSpdxIds: () => {},
  licensesSpdxIdsLoading: null,
  setLicensesSpdxIdsLoading: () => {}
});

function GenericContextWrapper({ children }) {
  const [licensesSpdxIds, setLicensesSpdxIds] = useState([]);
  const [licensesSpdxIdsLoading, setLicensesSpdxIdsLoading] = useState(false);

  const defaultValues = {
    licensesSpdxIds,
    setLicensesSpdxIds,
    licensesSpdxIdsLoading,
    setLicensesSpdxIdsLoading
  };

  return <GenericContext.Provider value={defaultValues}>{children}</GenericContext.Provider>;
}

export default GenericContextWrapper;
